export default "__VITE_IMAGE_ASSET__cf66c13b__";